import { useConsultation } from "../components/Consultation";
import { Reveal, Tag, LineReveal, ClipReveal, SolidButton, Marquee } from "../components/Shared";
import { IMAGES, MARQUEE_CITIES } from "../data/content";

export default function DesignerPage() {
  const { open } = useConsultation();
  return (
    <div className="bg-ink" data-testid="designer-page">
      <section className="mx-auto grid max-w-[1600px] items-center gap-16 px-5 pb-28 pt-36 sm:px-10 md:pt-44 lg:grid-cols-2">
        <div>
          <Reveal><Tag>The Designer</Tag></Reveal>
          <LineReveal lines={["RUTU", "BHONSLE"]} className="mt-6 font-serif text-7xl font-light leading-[0.92] tracking-tight sm:text-9xl" />
          <Reveal delay={0.3}>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.35em] text-flame">Designer. Creator. Storyteller.</p>
            <blockquote className="mt-10 border-l-2 border-flame pl-6 font-serif text-2xl font-light italic leading-snug text-bone/90 sm:text-3xl">
              “Fashion is not simply what we wear. It is how we enter a room, how we carry ourselves, and how we choose to be remembered.”
            </blockquote>
          </Reveal>
        </div>
        <ClipReveal src={IMAGES.designer} alt="Rutu Bhonsle — designer at work in the atelier" className="aspect-[4/5]" imgClassName="object-[62%_center]" />
      </section>

      <Marquee items={MARQUEE_CITIES} className="border-y border-white/10 py-8" />

      <section className="mx-auto max-w-[1600px] px-5 py-28 sm:px-10">
        <div className="grid gap-16 lg:grid-cols-[1fr_1.2fr]">
          <Reveal>
            <h2 className="font-serif text-4xl font-light leading-tight sm:text-5xl">
              A new language of <span className="text-flame">Indian fashion.</span>
            </h2>
          </Reveal>
          <div className="space-y-6 text-base font-light leading-relaxed text-fog">
            <Reveal delay={0.1}>
              <p>
                From its inception, the house of Rutu Bhonsle has focused on innovative prints, inclusive
                silhouettes and classic styles — an aesthetic built between Nagpur's textile heritage and
                the pace of international runways.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p>
                The collections have walked New York Fashion Week across three consecutive seasons — SS/17,
                SS/18 and SS/19 — followed by SMARÁ, the Spring/Summer 23 reflection on fashion's golden
                decade: exquisite chaos, minimalistic sophistication.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p>
                Today the house spans bespoke couture, bridal, ready-to-wear, menswear and kidswear — a
                single point of view, cut for every generation.
              </p>
            </Reveal>
            <Reveal delay={0.4} className="pt-4">
              <SolidButton onClick={open} testId="designer-page-consultation-button">Begin Your Commission</SolidButton>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
